export function Quote() {
  return (
    <section className="bg-gradient-to-b from-white via-orange-50 to-orange-100 py-16 px-4" id="quote">
      <div className="max-w-4xl mx-auto text-center">
        <div className="relative">
          {/* Quote shadow effect */}
          <div 
            className="absolute inset-0 bg-amber-900/10 blur-sm opacity-30 rounded-lg transform translate-y-3 translate-x-3" 
            id="quote-shadow"
          />
          
          {/* Main quote container */}
          <div className="relative bg-gradient-to-b from-amber-50 to-orange-50 shadow-xl rounded-lg px-8 py-12 border border-amber-200">
            <h2 
              className="text-3xl md:text-4xl font-normal text-amber-900 mb-6 leading-relaxed"
              id="quote-line-1"
              style={{ fontFamily: "'Goudy Bookletter 1911', Georgia, serif" }}
            >
              Best Vietnamese Food in Bend!!
            </h2>
            <p 
              className="text-base md:text-lg text-amber-800 font-normal tracking-wider uppercase"
              id="quote-line-2"
              style={{ fontFamily: "'Goudy Bookletter 1911', Georgia, serif" }}
            >
              BEND'S FAVORITE PHO, BANH MI, VERMICELLI BOWLS, AND MORE!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}